webpackJsonp([90],{

/***/ 2387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnauthorizedTravelErrorPage_vue__ = __webpack_require__(3247);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778daab6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnauthorizedTravelErrorPage_vue__ = __webpack_require__(3719);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3717)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnauthorizedTravelErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778daab6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnauthorizedTravelErrorPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/errors/UnauthorizedTravelErrorPage.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-778daab6", Component.options)
  } else {
    hotAPI.reload("data-v-778daab6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(283);
var client=function client(){return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({getCode:function getCode(code){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/codes/'+code));},showGroupDialog:function showGroupDialog(codeGroup){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/group/'+codeGroup));},getSpecialties:function getSpecialties(){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/specialties'));},getSpecialtiesInfo:function getSpecialtiesInfo(){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/specialties/info'));},getConsultationTypes:function getConsultationTypes(specialty){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/consultation-types'),{params:{specialtyId:specialty}});},getLanguages:function getLanguages(specialty){return client().get(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/languages'),{params:{specialtyId:specialty}});},resetCode:function resetCode(code,reservationNumber,startDate,endDate){return client().post(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* path */])('companies/code-resets',{code:code,reservationNumber:reservationNumber,startDate:startDate,endDate:endDate}));}});

/***/ }),

/***/ 3247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_CompaniesRepository__ = __webpack_require__(2585);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      code: null,
      isGenericCode: false,
      reservationNumber: null,
      startDate: null,
      endDate: null,
      submitError: null
    };
  },

  computed: {
    routeText: function routeText() {
      return this.$store.state.errorPageMessage;
    }
  },
  watch: {
    code: function code(val) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__repositories_CompaniesRepository__["a" /* default */].getCode(val).then(function (response) {
        _this.isGenericCode = response.data.generic;
      });
    }
  },
  methods: {
    send: function send() {
      var _this2 = this;

      // Check fields
      if (!this.code) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.code-required');
      } else if (this.genericCode && !this.reservationNumber) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.reservation-number-required');
      } else if (this.genericCode && (!this.startDate || !this.endDate || this.startDate > this.endDate)) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.start-date-required');
      } else {
        this.submitError = null;
        __WEBPACK_IMPORTED_MODULE_0__repositories_CompaniesRepository__["a" /* default */].resetCode(this.code, this.reservationNumber, this.startDate, this.endDate).then(function (response) {
          if (response) {
            _this2.$router.push('/patient');
          } else {
            _this2.submitError = _this2.$t('base.errors.unauthozed-travel-error-page.server-error');
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (!this.$route.query.t) {
      this.$router.push('/error/unauthorized');
    }
  }
});

/***/ }),

/***/ 3717:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3718);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("87821c62", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-778daab6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UnauthorizedTravelErrorPage.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-778daab6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./UnauthorizedTravelErrorPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3718:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 3719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.routeText) } }),
      _vm._v(" "),
      _vm.submitError
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _vm._v(_vm._s(_vm.submitError))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.code,
            expression: "code"
          }
        ],
        staticClass: "form-control mb-4",
        attrs: {
          type: "text",
          placeholder: _vm.$t(
            "base.errors.unauthozed-travel-error-page.new-code"
          )
        },
        domProps: { value: _vm.code },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.code = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.isGenericCode
        ? _c(
            "div",
            [
              _c("base-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "base.errors.unauthozed-travel-error-page.new-reservation-number"
                  )
                },
                model: {
                  value: _vm.reservationNumber,
                  callback: function($$v) {
                    _vm.reservationNumber = $$v
                  },
                  expression: "reservationNumber"
                }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("base-datepicker", {
                        attrs: {
                          placeholder: _vm.$t(
                            "base.errors.unauthozed-travel-error-page.new-start-date"
                          )
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("base-datepicker", {
                        attrs: {
                          placeholder: _vm.$t(
                            "base.errors.unauthozed-travel-error-page.new-end-date"
                          )
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-button", { on: { click: _vm.send } }, [
        _vm._v(_vm._s(_vm.$t("continue")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-778daab6", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/90.02321049f8272988a81f.js